import { render, staticRenderFns } from "./MegaMenuTablet.vue?vue&type=template&id=4b0b5e58&scoped=true"
import script from "./MegaMenuTablet.vue?vue&type=script&lang=js"
export * from "./MegaMenuTablet.vue?vue&type=script&lang=js"
import style0 from "./MegaMenuTablet.vue?vue&type=style&index=0&id=4b0b5e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b5e58",
  null
  
)

export default component.exports